import React from 'react';
import { Outlet } from 'react-router-dom';
import { FederalHeader } from './FederalHeader';
import { SideNav } from './SideNav';
import { CommandSearch } from './CommandSearch';
export function AppShell() {
  const [searchOpen, setSearchOpen] = React.useState(false);
  React.useEffect(() => {
    function onKeyDown(event: KeyboardEvent) {
      const target = event.target as HTMLElement | null;
      const typing = target && ['INPUT', 'TEXTAREA'].includes(target.tagName);
      if (event.key === '/' && !typing) {
        event.preventDefault();
        setSearchOpen(true);
      }
    }
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);
  return <div className="flex min-h-screen w-full flex-col bg-background" data-id="element-688" data-mp="2u39oearc30k">
      <FederalHeader onSearch={() => setSearchOpen(true)} data-id="element-689" data-mp="10a8oicv79qp2" />
      <div className="flex w-full flex-1" data-id="element-690" data-mp="10btmydkmxts7">
        <SideNav data-id="element-691" data-mp="vi8vz5hgm02i" />
        <main className="min-w-0 flex-1" data-id="element-692" data-mp="vhpcvlg2p5mw">
          <Outlet data-id="element-693" data-mp="2bejpgqu2q3h2" />
        </main>
      </div>
      <CommandSearch open={searchOpen} onOpenChange={setSearchOpen} data-id="element-694" data-mp="2bfuuetz99h9r" />
    </div>;
}